"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.string.sub.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.array.slice.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _slicedToArray2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _index = require("@/model/exchange/index");

var _socket = _interopRequireDefault(require("@/assets/js/socket.js"));

var _vuex = require("vuex");

var _settings = require("@/model/settings");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  mixins: [_commonMixin.default],
  props: {},
  data: function data() {
    return {
      tt: {},
      lockReconnect: false,
      coinFrom: "--",
      coinTo: "--",
      colorClass: "",
      swap_symbol_id: "",
      selfOptionsList: [],
      symbolList: [],
      depthList: {
        a: [["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"]],
        b: [["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"], ["--", "--"]]
      },
      from_symbol: "",
      to_symbol: "",
      tableLoading: false,
      wsUrl: null
    };
  },
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var tempSymbol, key, _this$symbolList$key$, _this$symbolList$key$2, coinFrom, coinTo;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getTradePairList();

            case 2:
              tempSymbol = _this.$route.query.symbol;
              _this.from_symbol = tempSymbol;

              for (key in _this.symbolList) {
                if (_this.symbolList[key].symbol == _this.from_symbol) {
                  _this$symbolList$key$ = _this.symbolList[key].name.split("_"), _this$symbolList$key$2 = (0, _slicedToArray2.default)(_this$symbolList$key$, 2), coinFrom = _this$symbolList$key$2[0], coinTo = _this$symbolList$key$2[1];
                  _this.from_symbol = coinFrom;
                  _this.to_symbol = coinTo;
                  _this.swap_symbol_id = _this.symbolList[key].symbol_id;
                }
              }

              _context.next = 7;
              return _this.initURL();

            case 7:
              _this.initWS();

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    goback: function goback() {
      window.history.back();
    },
    initURL: function initURL() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, _yield$apiWsUrl, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  __version: "3.4.3"
                };
                _context2.next = 3;
                return (0, _index.apiWsUrl)(params);

              case 3:
                _yield$apiWsUrl = _context2.sent;
                status = _yield$apiWsUrl.status;
                data = _yield$apiWsUrl.data;

                if (status == 200) {
                  _this2.wsUrl = data.ws3_url;
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    initWS: function initWS() {
      var me = this;
      this.tableLoading = true;
      var wsUrl = this.wsUrl;
      var option = {
        url: wsUrl,
        subData: {
          action: "Topic.sub",
          data: {
            type: "depth",
            symbol: me.swap_symbol_id
          }
        },
        callback: me.onResponse,
        onConnect: onConnect,
        mounted: mounted
      };

      function mounted() {
        me.ws.sub({
          action: "Topic.sub",
          data: {
            type: "market",
            symbol: me.swap_symbol_id
          }
        });
        me.ws.sub({
          action: "Topic.sub",
          data: {
            type: "depth",
            symbol: me.swap_symbol_id
          }
        });
      }

      window.USDT_WS = this.ws = new _socket.default(option).getInstance(); // 重新连接

      function onConnect() {
        if (me.lockReconnect) return;
        me.lockReconnect = true;
        me.tt && clearTimeout(me.tt);
        me.tt = setTimeout(function () {
          console.log("ws重連");
          me.initWs();
          me.lockReconnect = false;
        }, 3000);
      }
    },
    onResponse: function onResponse(data) {
      var me = this;

      if (data.action == "Pushdata.depth") {
        if (data.data) {
          if (!data.params.p) {
            return;
          }

          var tempObj = data.data;

          if (tempObj.a.length > 0) {
            tempObj.c = 0;
            tempObj.d = 0;
            tempObj.a.forEach(function (ele) {
              tempObj.c += Number(ele[1]);
            });
            tempObj.b.forEach(function (ele) {
              tempObj.d += Number(ele[1]);
            });
          }

          me.depthList = tempObj;
        }
      }
    },
    getTradePairList: function getTradePairList() {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$apiGetStaticTa, status, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(58);

              case 2:
                _yield$apiGetStaticTa = _context3.sent;
                status = _yield$apiGetStaticTa.status;
                data = _yield$apiGetStaticTa.data;

                if (status == 200) {
                  _this3.symbolList = data;
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  },
  watch: {},
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    userInfo: "user/userInfo"
  })), {}, {
    from_symbol_show: function from_symbol_show() {
      return this.from_symbol.toUpperCase() || "--";
    },
    to_symbol_show: function to_symbol_show() {
      return this.to_symbol.toUpperCase() || "--";
    },
    totleBuy: function totleBuy() {
      return this.depthList.c;
    },
    bigBuy: function bigBuy() {
      var temp = Number(this.depthList.a[0][1]);

      for (var i = 0; i < this.depthList.a.length - 1; i++) {
        temp = temp < Number(this.depthList.a[i + 1][1]) ? Number(this.depthList.a[i + 1][1]) : temp;
      }

      return temp;
    },
    bigSell: function bigSell() {
      var temp = Number(this.depthList.b[0][1]);

      for (var i = 0; i < this.depthList.b.length - 1; i++) {
        temp = temp < Number(this.depthList.b[i + 1][1]) ? Number(this.depthList.b[i + 1][1]) : temp;
      }

      return temp;
    },
    totleSell: function totleSell() {
      return this.depthList.d;
    },
    // a卖  b买
    showListSell: function showListSell() {
      return this.depthList.a.slice(0, 50);
    },
    showListBuy: function showListBuy() {
      return this.depthList.b.slice(0, 50);
    },
    className: function className() {
      var className = "";

      if (!this.marketInfoShow.info.price_change_percent) {
        className = "";
      } else if (this.marketInfoShow.info.price_change_percent > 0) {
        className = "green";
      } else if (this.marketInfoShow.info.price_change_percent < 0) {
        className = "red";
      }

      return className;
    }
  })
};
exports.default = _default;